/**
 * /settings/webhooks — operator page for feature FS-230 (Webhook CRUD).
 *
 * Declares a TanStack Router route and renders the `WebhookCrudPage` feature.
 * Root wire-up picks this up from `router.tsx`.
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { WebhookCrudPage } from "@/features/webhook-crud/WebhookCrudPage";

export const settingsWebhooksRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/settings/webhooks",
	component: SettingsWebhooksRoute,
});

export default settingsWebhooksRoute;

export function SettingsWebhooksRoute() {
	return (
		<div className="flex flex-col">
			<nav
				aria-label="Breadcrumb"
				className="mx-auto w-full max-w-6xl px-6 pt-10 text-sm text-zinc-500 sm:pt-16"
			>
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-[6px] px-1 py-0.5">Settings</span>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li className="text-zinc-900">Webhooks</li>
				</ol>
			</nav>

			<WebhookCrudPage />
		</div>
	);
}

// Named export for the root wire-up cycle.
export { SettingsWebhooksRoute as SettingsWebhooksPage };
